import {
  Box,
  Stack,
  ListSubheader,
  List,
  ListItemButton,
  ListItemText,
  Divider,
} from '@mui/material';
import { FunctionComponent } from 'react';
import Gallery from '../../inspection/photos';
import './index.scss';
import { PhotoSection } from '@src/types/images';
import { ClaimantType } from '@src/types/claimsTracker';
import { IFlag } from '@components/claims/information/CPEFlags';

interface ClaimsSections {
  eventRecord: string;
  claimantType: ClaimantType;
  inspectionFlags?: IFlag[];
  setInspectionFlags?: React.Dispatch<React.SetStateAction<IFlag[]>>;
}

const Photos: FunctionComponent<ClaimsSections> = ({
  eventRecord,
  claimantType,
  inspectionFlags,
  setInspectionFlags,
}): JSX.Element => {
  const handleClick = (_: string, photoSection: PhotoSection) => {
    const element = document.getElementById(`imageSection_${photoSection}`);
    element?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={{ xs: 1, sm: 2, md: 4 }}
    >
      <Box>
        <List
          className="menu"
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader
              component="div"
              id="nested-list-subheader"
              className="menu__header"
            >
              <p>Fotos</p>
            </ListSubheader>
          }
        >
          <ListItemButton
            className="menu__list"
            onClick={() =>
              handleClick('Odómetro', PhotoSection.INSURED_ODOMETER)
            }
          >
            <ListItemText primary="Odómetro" className="item-text" />
          </ListItemButton>
          <Divider variant="middle" component="li" />
          <ListItemButton
            className="menu__list"
            onClick={() => handleClick('Marbete', PhotoSection.INSURED_MARBETE)}
          >
            <ListItemText primary="Marbete" className="item-text" />
          </ListItemButton>
          <Divider variant="middle" component="li" />
          <ListItemButton
            className="menu__list"
            onClick={() =>
              handleClick('Otros', PhotoSection.INSURED_OTHERS_DOCS)
            }
          >
            <ListItemText primary="Otros" className="item-text" />
          </ListItemButton>
        </List>
      </Box>
      <Box
        sx={{
          width: '100%',
          minHeight: '300px',
          backgroundColor: 'white',
          borderRadius: '4px',
          padding: '10px',
        }}
      >
        <Gallery
          country={localStorage.getItem('countryCode') || ''}
          eventRecord={eventRecord}
          claimantType={claimantType}
          sectionType="INSPECTIONS"
          handleSavePhoto={() => {
            console.warn('saved photo');
          }}
          inspectionFlags={inspectionFlags}
          setInspectionFlags={setInspectionFlags}
        />
      </Box>
    </Stack>
  );
};

export default Photos;
